import {useEffect} from "react";
import traitify from "traitify-widgets";
import {dig, mutable} from "lib/ext/object";
import useAppContext from "lib/hooks/use-app-context";

export default function useTraitifyWidgets() {
  const {app: {api}, user} = useAppContext();
  const locale = dig(user, "profile", "primary_language");

  useEffect(() => {
    if(!api) { return; }

    traitify.http.authKey = api.key;
    traitify.http.host = api.host;
    traitify.http.version = api.version;
  }, [api]);

  useEffect(() => {
    if(!locale) { return; }

    traitify.updateLocale(locale);
  }, [locale]);

  if(!api) { return null; }

  return mutable(traitify.props);
}
